module.exports = __webpack_public_path__ + "img/Lock Icon - white.64a1c96f.svg";